module.exports = __webpack_public_path__ + "static/img/149.0c04220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/149.png
// module id = wCTa
// module chunks = 0